/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".show-image-modal{position:static}.show-image-modal img{height:300px;-o-object-fit:contain;object-fit:contain}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.image.modal/show.image.modal.component.scss.ngstyle.js.pre-build-optimizer.js